module.exports = __webpack_public_path__ + "d97f5a43775de32b593aab88dc5b4272.svg";